import { styled } from '@mui/system';

import { LockOutlineIcon } from '@app-velocity/icons';

import { Typography } from '../../Typography';

export type BadgeProps = {
  text: string;
};

const StyledBadge = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(4),
  padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  background: '#F7EEE6',
  color: 'var(--text-text-primary-color)',
  svg: {
    fill: '#F28511',
  },
}));

export const Badge = ({ text }: BadgeProps) => {
  return (
    <StyledBadge>
      <LockOutlineIcon />
      <Typography>{text}</Typography>
    </StyledBadge>
  );
};
